import { atom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';

export type FloatingOpenButtonPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'middleLeft'
  | 'middleRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

export const developerMenuOpenAtom = atom(false);

export const jotaiDevToolsOpenAtom = atom(false);
export const reactQueryDevtoolsOpenAtom = atom(false);

export const openButtonPositionAtom =
  atomWithStorage<FloatingOpenButtonPosition>(
    'developer-menu-open-button-position',
    'middleRight',
    undefined,
    {
      getOnInit: true,
    },
  );

export const developerMenuOpenButtonHiddenAtom = atomWithStorage(
  'developer-menu-open-button-hidden',
  false,
  undefined,
  {
    getOnInit: true,
  },
);

export const developerMenuSearchQueryAtom = atom('');

export const debugSearchSessionAtom = atom(false);
debugSearchSessionAtom.debugLabel = 'debugSearchSession';

/* ------- Subcommand Modal State ------- */

export type SubcommandModalKey = 'permissions';

export const subcommandModalOpenAtomFamily = atomFamily(
  (_: SubcommandModalKey) => atom(false),
);

/* -------------------------------------- */
